document.addEventListener("DOMContentLoaded", e => {
const observer = new MutationObserver(() => {
  const productPriceBlock = document.querySelector(".product-info__block.product-price");
  const formElement = document.querySelector(".product-info__block.product-price form");

  if (productPriceBlock && formElement) {
    if (productPriceBlock.nextElementSibling !== formElement) {
      productPriceBlock.insertAdjacentElement("afterend", formElement);
      observer.disconnect();
    }
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,   
});
const checkHideVariant = (currentVariantId) => {
    const priceEl = document.querySelector('.product-info .buy-btns-wrapper');
    const hideVariantMessage = priceEl.querySelector('.bss-lock-element'); 
    if (listVariantRestrict.includes(currentVariantId)) {
        if (!hideVariantMessage) priceEl.insertAdjacentHTML("afterbegin", '<span class="bss-lock-element"><span class="bss-lock-price-access-deniend" style="color: #000000; font-size: 12px; font-family: initial; font-weight: normal; font-style: normal; display: block; text-decoration: none; line-height: normal;">Login with your wholesale account to view prices.</span></span>')
    } else {
        priceEl.querySelectorAll('.bss-lock-element').forEach((item) => item.remove());
    }
};

setTimeout(() => {
  const cartForm = document.querySelector("product-form form[action='/cart/add'] input[name='id']");
  if (cartForm) {
      // checkHideVariant(cartForm.value, true);
      const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                  checkHideVariant(cartForm.value);
              }
          }
      });
      observer.observe(cartForm, { attributes: true, attributeFilter: ['value'] });
  }
}, 500)


if(BSS_B2B && BSS_B2B.shopData) {
      const customerData = BSS_B2B.shopData.customer;
      const isWholesaleCustomer = customerData && customerData.tags && customerData.tags.length && customerData.tags.includes("wholesale")
      const elements = document.querySelectorAll('.bss-b2b-custom-fields');
      if (!isWholesaleCustomer) {
        elements.forEach(function(element) {
            const parent = element.parentElement;
            if (parent) {
                parent.remove();
            }
        });
      }
}

  const isCart = window.location.pathname === '/cart';
  if(isCart) {
    document.querySelector("cart-drawer")?.remove();
  }
  const bssOrderNote = document.querySelector(".bss-b2b-custom-fields");
  const cartNoteOrig = document.querySelector("details-disclosure");
  cartNoteOrig.insertAdjacentElement("afterEnd", bssOrderNote);
  const cartNoteBSS = document.querySelector(".bss-cart-note");
  if(cartNoteBSS) cartNoteBSS.value = ''; 
})